export default {
  eula: 'Contrat de licence d\'utilisateur final',
  serviceTerms: 'Modalités de service',
};
